import {
    NEW_ANO_PECUARIO_CADASTRO_SUCCESS,
    CANCEL_ANO_PECUARIO_CADASTRO_RAPIDO_SUCCESS,
    TABLE_ANO_PECUARIO_CADASTRO_PENDING,
    TABLE_ANO_PECUARIO_CADASTRO_SUCCESS,
    TABLE_ANO_PECUARIO_CADASTRO_FAILURE,
    LIST_ANO_PECUARIO_CADASTRO_PENDING,
    LIST_ANO_PECUARIO_CADASTRO_SUCCESS,
    LIST_ANO_PECUARIO_CADASTRO_FAILURE,
    FIND_ANO_PECUARIO_CADASTRO_PENDING,
    FIND_ANO_PECUARIO_CADASTRO_SUCCESS,
    FIND_ANO_PECUARIO_CADASTRO_FAILURE,
    DELETE_ANO_PECUARIO_CADASTRO_PENDING,
    DELETE_ANO_PECUARIO_CADASTRO_SUCCESS,
    DELETE_ANO_PECUARIO_CADASTRO_FAILURE,
    CREATE_ANO_PECUARIO_CADASTRO_PENDING,
    CREATE_ANO_PECUARIO_CADASTRO_SUCCESS,
    CREATE_ANO_PECUARIO_CADASTRO_FAILURE,
    NEW_ANO_PECUARIO_CADASTRO_PENDING,
} from './actionTypes';


const initialState = { list: null, loading: false }


function anoPecuarioCadastroReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_ANO_PECUARIO_CADASTRO_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: action.isCadastroRapido ?? false,
            }
        case NEW_ANO_PECUARIO_CADASTRO_PENDING:
        case LIST_ANO_PECUARIO_CADASTRO_PENDING:
        case FIND_ANO_PECUARIO_CADASTRO_PENDING:
        case DELETE_ANO_PECUARIO_CADASTRO_PENDING:
        case CREATE_ANO_PECUARIO_CADASTRO_PENDING:
        case TABLE_ANO_PECUARIO_CADASTRO_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CANCEL_ANO_PECUARIO_CADASTRO_RAPIDO_SUCCESS:
            return {
                ...state,
                isCadastroRapido: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_ANO_PECUARIO_CADASTRO_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_ANO_PECUARIO_CADASTRO_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_ANO_PECUARIO_CADASTRO_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_ANO_PECUARIO_CADASTRO_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_ANO_PECUARIO_CADASTRO_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_ANO_PECUARIO_CADASTRO_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_ANO_PECUARIO_CADASTRO_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_ANO_PECUARIO_CADASTRO_SUCCESS:
        case CREATE_ANO_PECUARIO_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: false,
            }
        case DELETE_ANO_PECUARIO_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { anoPecuarioCadastroReducer };